import React, { useEffect, useState, useCallback } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { useProjectState } from '@client/store/project';
import { getErrorResponseMessage } from '@client/hooks/use-error-handler.hooks';

export const ProjectErrors: React.FC = () => {
  const projects = useProjectState('error');
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleClose = useCallback(() => setErrorMessage(undefined), []);

  useEffect(() => {
    if (projects.error) {
      setErrorMessage(getErrorResponseMessage(projects.error));
    }
  }, [projects.error]);

  return (
    <Snackbar
      open={!!errorMessage}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert variant="filled" severity="error">
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};
